/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Cards_TitleInputs */

const en_mk_team_cards_title = /** @type {(inputs: Mk_Team_Cards_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decision Cards`)
};

const id_mk_team_cards_title = /** @type {(inputs: Mk_Team_Cards_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu Keputusan`)
};

/**
* | output |
* | --- |
* | "Decision Cards" |
*
* @param {Mk_Team_Cards_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_cards_title = /** @type {((inputs?: Mk_Team_Cards_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Cards_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_cards_title(inputs)
	return en_mk_team_cards_title(inputs)
});